import type {
  DetectLanguageRequest,
  DetectLanguageResponse,
  ImageFeaturesResponse,
  StarImprovementResponse,
  TranslateLanguageRequest,
  TranslateLanguageResponse,
} from '@dashhudson/api-client/library-intelligence/model';

import {
  getBrandBrandIdStarImprovement,
  getPostDetectLanguageUrl,
  getPostTranslateLanguageUrl,
  getPostVectoriseV2Url,
} from '@dashhudson/api-client/library-intelligence/client';
import { merge } from 'lodash-es';

import { createDashHttpClient, type HttpRequestConfig } from '@/apis/dash.http';
import { env } from '@/env';

export const http = createDashHttpClient(env.libraryIntelligenceApiUrl, {
  camelizeKeys: true,
});

/**
 * Get visual features string from image data
 *
 * Expects a base64 encoding for a jpg image (excluding MIME type).
 * Uses a HTML form content-type rather than JSON, per intelligence's endpoint.
 */
export async function vectoriseV2(
  { imageData: img }: { imageData: string },
  config: HttpRequestConfig = {},
) {
  return http.post<ImageFeaturesResponse>(
    getPostVectoriseV2Url(),
    { img },
    merge({ headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }, config),
  );
}

/** Average star improvement for a brand over the last year; `ready: false` means the backend is still computing. */
export async function getStarImprovement(
  { brandId }: { brandId: number },
  options: RequestInit = {},
): Promise<StarImprovementResponse> {
  return getBrandBrandIdStarImprovement(brandId, undefined, options);
}

export async function detectTextLanguage(
  { texts }: Pick<DetectLanguageRequest, 'texts'>,
  config: HttpRequestConfig = {},
) {
  return http.post<DetectLanguageResponse>(getPostDetectLanguageUrl(), { texts }, config);
}

export async function translateTextLanguage(
  { texts }: Pick<TranslateLanguageRequest, 'texts'>,
  config: HttpRequestConfig = {},
) {
  return http.post<TranslateLanguageResponse>(getPostTranslateLanguageUrl(), { texts }, config);
}
